<template>
  <div>
    <div class="router-content page-right-header">
      <vs-button color="primary" type="filled" @click="showAddEditDialog = true">Add Employee</vs-button>
    </div>
    <vs-popup
      class="holamundo digitelex-popup"
      :title="modalTitle"
      :active.sync="showAddEditDialog"
    >
      <addEditEmployee
        :frmData="currentEditRow ? currentEditRow : formData"
        v-if="showAddEditDialog"
        @submitResponse="reloadData"
      ></addEditEmployee>
    </vs-popup>
    <div id="ag-grid-container">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">
                  {{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                  employees.length - currentPage * paginationPageSize > 0
                  ? currentPage * paginationPageSize
                  : employees.length
                  }}
                  of {{ employees.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-input
              class="mb-4 md:mb-0 mr-4"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search..."
            />
            <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
          </div>
        </div>
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="employees"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :context="context"
          :tooltipShowDelay="'0'"
          :overlayLoadingTemplate="overlayLoadingTemplate"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
        ></ag-grid-vue>
        <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { EventBus } from "./../../../utils/grid/eventbus.js";
import addEditEmployee from "./add-edit-employee";

let actionsTemplate = {
  template: `<div class="flex">
      <vs-button class="w-1/2 h-12 flex"  @click="editEmployee" size="large"radius color="primary" type="flat" icon-pack="feather" icon="icon-edit"></vs-button>
      <vs-button class="w-1/2 h-12 flex" @click="deleteEmployee" size="large"radius color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
    </div>`,
  methods: {
    editEmployee() {
      EventBus.$emit("editEmployee", { item: this.params });
    },
    deleteEmployee() {
      EventBus.$emit("deleteEmployee", { item: this.params });
    },
  },
  beforeMount() {},
};
export default {
  components: {
    "ag-grid-vue": AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    actionsTemplate: actionsTemplate,
    addEditEmployee: addEditEmployee,
  },
  beforeMount() {
    this.overlayLoadingTemplate =
      '<span class="ag-overlay-loading-center">Please wait while loading Employees</span>';
    this.overlayNoRowsTemplate =
      '<span class="ag-overlay-loading-center">No Employees found!</span>';
    this.context = {
      componentParent: this,
    };
    this.$http.get("core/users").then((response) => {
      // console.log(response);
      this.employees = response.data.data;
    });
  },
  data() {
    return {
      showAddEditDialog: false,
      currentEditRow: null,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      context: null,
      modalTitle: "Add Employee",
      formData: {
        viewEmployee: true,
        employeeFirstName: null,
        employeeLastName: null,
        userId: 0,
        branchId: 0,
        designationId: 0,
        employeeEmail: null,
        employeeId: 0,
        employeeMobileNo: null,
        employeePhoto: null,
        employeeUniq: null,
        locationId: 0,
        employeeAddress: null,
        userName: null,
        isActive: null,
        accessProfiles: [],
        roles: [],
        accessProfilesArray: [],
      },
      overlayLoadingTemplate: null,
      overlayNoRowsTemplate: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "Actions",
          width: 150,
          filter: false,
          pinned: "left",
          cellRendererFramework: "actionsTemplate",
        },
        {
          headerName: "First Name",
          headerTooltip: "First Name",
          field: "employeeFirstName",
          width: 250,
          filter: true,
          tooltipField: "employeeFirstName",
          pinned: "left",
        },
        {
          headerName: "Last Name",
          headerTooltip: "Last Name",
          field: "employeeLastName",
          filter: true,
          width: 250,
          tooltipField: "employeeLastName",
        },
        {
          headerName: "User Name",
          headerTooltip: "User Name",
          field: "userName",
          filter: true,
          width: 250,
          tooltipField: "userName",
        },
        {
          headerName: "Location",
          headerTooltip: "Location",
          field: "locationName",
          filter: true,
          width: 250,
          tooltipField: "locationName",
        },
        {
          headerName: "Branch",
          headerTooltip: "Branch",
          field: "branchName",
          filter: true,
          width: 250,
          tooltipField: "branchName",
        },
        {
          headerName: "Email",
          headerTooltip: "Email",
          field: "employeeEmail",
          filter: true,
          width: 250,
          tooltipField: "employeeEmail",
        },
        {
          headerName: "Mobile No",
          headerTooltip: "Mobile No",
          field: "employeeMobileNo",
          filter: true,
          width: 250,
          tooltipField: "employeeMobileNo",
        },
        {
          headerName: "Designation",
          headerTooltip: "Designation",
          field: "designationName",
          filter: true,
          width: 250,
          tooltipField: "designationName",
        },
        {
          headerName: "Address",
          headerTooltip: "Address",
          field: "employeeAddress",
          filter: true,
          width: 250,
          tooltipField: "employeeAddress",
        },
      ],
      employees: [],
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("employeeFirstName", null);
      } else
        this.gridOptions.columnApi.setColumnPinned("employeeFirstName", "left");
    },
    showAddEditDialog: function () {
      Object.keys(this.formData).forEach((key) => {
        if (typeof key === "string") this.formData[key] = "";
        else if (typeof key === "boolean") this.formData[key] = false;
        else if (typeof key === "number") this.formData[key] = 0;
        else this.formData[key] = "";
      });
      if (!this.showAddEditDialog) {
        this.currentEditRow = false;
      }
    },
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    reloadData(_event) {
      // alert("ReloadData");
      this.showAddEditDialog = false;
      // console.log(_event);
      this.employees = _event.data;
      this.$vs.notify({
        title: _event.message,
        color: "success",
        position: "top-right",
      });
      this.gridApi.setRowData(_event.data);
    },
    deleteClient(_e) {
      // console.log(_e);
      this.$http
        .put("common/location", _e.data)
        .then((response) => {
          // text:'Lorem ipsum dolor sit amet, consectetur',

          this.$vs.notify({
            title: response.data.message,
            color: "success",
            position: "top-right",
          });
          this.gridApi.setRowData(response.data.data);
          // this.$emit("submitResponse", response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    EventBus.$on("editEmployee", (employeeData) => {
      // console.log(employeeData);
      this.currentEditRow = employeeData.item.data;
      this.showAddEditDialog = true;
    });
    EventBus.$on("deleteEmployee", (employeeData) => {
      // this.currentEditRow = clientData.item.data;
      let rowData = employeeData;
      rowData.item.data.isActive = false;
      // console.log(employeeData);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Employee?`,
        text: ``,
        acceptText: "Accept!",
        accept: this.deleteClient,
        parameters: rowData.item,
      });
      setTimeout(() => {
        if (document.getElementsByClassName("vs-dialog-text").length > 0) {
          document.getElementsByClassName(
            "vs-dialog-text"
          )[0].innerHTML = `Do you want to delete below Location?<br/><blockquote>Location Name: <b>${rowData.item.data.locationName}</b></blockquote>`;
        }
      }, 0);

      // this.showAddEditDialog = true;
    });
  },
};
</script>